export default {
	es: {
		enlaces: {
			login: '/login',
			restablecer_login: '/restablecer-tutor',
			validaciones: '/validaciones',
			evaluaciones: "/evaluaciones",
			tutorados: "/tutorados",
			ficha: "/ficha",
			fichaaprobacion: "/aprobacion",
			encuesta: '/encuesta',
			encuestas: '/encuestas',
			acceso: '/acceso',
			miperfil: '/mi-perfil',
			aprobacionesdirector: '/aprobaciones',
			"1": "pendientes",
			"2": "validadas",
			"3": "rechazadas",
			anexos: '/anexos',
		},
		encabezado: {
			home: 'Bienvenid@',
			politica_privacidad: "Política de privacidad",
			politica_cookies: "Política de cookies",
			login: "Inicio de sesión",
			documentacion: 'Documentación',
			restablecer_login: 'Restablecer Contraseña',
			encuesta: 'Encuesta',
			acceso: 'Acceso'
		},
		escribe_buscar: "Escribe para buscar",
		no_hay_datos: "NO HAY DATOS",
		descargar: "Descargar",
		columnas: "Columnas",
		encuestas: "Encuestas",
		comenzar: "Comenzar",
		ver_practica: "Ver práctica relacionada",
		empresa: "Empresa",
		datos_empresa: "Datos de la empresa",
		cif: "CIF",
		nombre_comercial: "Nombre comercial",
		sector: "Sector",
		direccion: "Dirección",
		localidad: "Localidad",
		provincia: "Provincia",
		cp: "Código Postal",
		pais: "País",
		web_empresa: "Web de la empresa",
		descripcion: "Descripción",
		contacto_empresa: "Contactos de la empresa",
		nombre_apellidos: "Nombre y apellidos",
		puesto: "Puesto",
		telefono: "Teléfono",
		email: "Email",
		estudiante: "Estudiante",
		datos_personales: "Datos personales",
		nombre: "Nombre",
		apellidos: "Apellidos",
		movil: "Móvil",
		fijo: "Fijo",
		fecha_nacimiento: "Fecha de nacimiento",
		pais_nacionalidad: "País de nacionalidad",
		direccion: "Dirección",
		poblacion: "Población",
		provincia: "Provincia",
		discapacidad: "Discapacidad",
		si: "Sí",
		no: "No",
		documentos: "Documentos",
		descargar_excel: "Descargar excel",
		firmar: "Firmar",
		firmar_seleccionados: "Firmar seleccionados",
		datos_academicos: "Datos acádemicos en curso",
		titulacion: "Titulación",
		matriculado_practicas: "Matriculado de prácticas",
		practicas_pendientes: "Prácticas pendientes",
		ver_cv_estudiante: "Ver CV del estudiante",
		autorizacion_cuatrimestre: "Autorización por Cuatrimestre",
		anyo: "Año",
		codigo_estudio: "Código de estudio",
		autorizacion: "Autorización",
		periodo: "Periodo",
		fecha_resolucion: "Fecha de resolución",
		horas: "Horas",
		observaciones: "Observaciones",
		no_tiene_observaciones: "Esta práctica no contiene observaciones",
		datos_practica: "Datos de la práctica",
		id_practica: "Id Práctica",
		nombre_gestor: "Nombre gestor",
		detalles_puesto: "Detalles del puesto",
		tipo_practica: "Tipo de práctica",
		nombre_puesto: "Nombre del puesto",
		area_funcional: "Área funcional",
		ayuda_al_estudio: "Ayuda al estudio",
		tareas_desarrollar: "Tareas a desarrollar",
		tarea: "Tarea",
		otras_tareas: "Otras tareas",
		motivos_solicitud: "Motivos de solicitud de Validación",
		ver_documento_prorroga: "Ver documento de prórroga",
		duracion: "Duración",
		fecha_inicio: "Fecha de inicio",
		fecha_finalizacion: "Fecha de finalización",
		horario: "Horario",
		n_horas_dia: "Nº horas al día",
		horas_totales: "Horas totales",
		dias_semana: "Días en semana",
		horas_curriculares: "Horas curriculares",
		horas_extracurriculares: "Horas extracurriculares",
		numero_creditos: "Número de créditos",
		nombre_centro: "Nombre del centro de trabajo",
		tutor_empresa: "Tutor/a en la empresa",
		departamento: "Departamento",
		ver_anexo_practicas: "Ver documento anexo de prácticas",
		cuestionarios: "Cuestionarios",
		ver_cuestionario_empresa: "Ver cuestionario de la empresa",
		ver_evaluacion_empresa: "Ver evaluación de la empresa",
		ver_cuestionario_alumno: "Ver cuestionario del alumno/a",
		ver_evaluacion_alumno: "Ver evaluación del alumno/a",
		ver_cuestionario_tutor: "Ver cuestionario del tutor/a académico/a",
		ver_evaluacion_tutor: "Ver evaluación del tutor/a académico/a",
		ver_actilla_calificacion: "Ver actilla de calificación",
		documento_evaluacion: "Documento de Evaluación del tutor/a",
		cuestionarios_tutor: "Cuestionarios del tutor/a académico/a contestados",
		seguimiento: "Seguimiento",
		fecha_practica: "Fecha de práctica asignada",
		fecha_limite_estudiante: "Fecha límite de entrega estudiante",
		fecha_cuestionario_estudiante: "Fecha cuestionario/memoria estudiante",
		fecha_limite_empresa: "Fecha límite de entrega empresa",
		fecha_cuestionario_empresa: "Fecha cuestionario empresa",
		fecha_cierre_pendiente: "Fecha de cierre pendiente",
		fecha_cierre_tramitado: "Fecha de cierre tramitado",
		motivos_solicitud_validacion: "Motivos para la solicitud de la validación",
		documentacion_tutor: "Documentación del tutor/a académico/a",
		anadir_documentacion: "Añadir documentación",
		solicitar_cuestionario_alumno: "Solicitar evaluación alumno",
		solicitar_cuestionario_tutor: "Solicitar evaluación tutor",
		anadir_evaluacion: "Añadir evaluación",
		documentacion_por_programas: "Documentación por programas",
		ver_documento: "Ver documento",
		documentacion_ofrecida: "Documentación ofrecida",
		documentacion_pendiente_subir: "Documentación pendiente de subir",
		anadir_documento: "Añadir documento",
		iniciar_sesion: "Iniciar sesión",
		contrasena: "Contraseña",
		he_perdido_contrasena: "He olvidado mi contraseña",
		acceder: "Acceder",
		introducir_email: "Introduce tu email",
		email_mal_formado: "El email está mal formado",
		recuperar_contrasena: "Recuperar mi contraseña",
		mi_perfil: "Mi perfil",
		datos_personales_contacto: "Datos personales y de contacto",
		sin_introducir: "Sin introducir",
		dni: "DNI/NIE",
		email_personal: "Email personal",
		telefono_profesional: "Teléfono profesional/despacho",
		telefono_movil: "Teléfono móvil",
		datos_profesionales: "Datos profesionales",
		tipo: "Tipo",
		area: "Área",
		cargo: "Cargo",
		datos_facturacion: "Datos de facturación",
		selecciona_pais: "-selecciona un país-",
		provincia: "Provincia",
		selecciona_provincia: "-selecciona una provincia-",
		localidad: "Localidad",
		direccion_fiscal: "Dirección Fiscal",
		numero_cuenta: "Número de cuenta, IBAN",
		editar_datos: "Editar datos",
		guardar_datos: "Guardar datos",
		si_datos_erroneos: "Si alguno de los datos no editables en tu perfil no es correcto, por favor contacta con nosotros/as.",
		sigue_pasos: "Sigue los pasos para restablecer tu contraseña",
		nueva_contrasena: "Nueva Contraseña",
		repetir_contrasena: "Repetir nueva Contraseña",
		guardar: "Guardar",
		ver_documento_adjunto: "Ver documento adjunto",
		resultados_cuestionario: "Resultados del cuestionario",
		informacion_puesto: "Información puesto",
		datos_generales: "Datos generales",
		titulaciones: "Titulaciones",
		conocimientos_especificos: "Conocimientos específicos",
		formacion_adquirida: "Formación Adquirida",
		nombre_oferta: "Nombre de la oferta",
		n_plazas: "Nº de plazas",
		descripcion_puesto: "Descripción del puesto",
		duracion: "Duración",
		horas_dia: "Horas/día",
		horario: "Horario",
		localizacion: "Localización",
		detalles: "Detalles",
		remuneracion: "Remuneración",
		otras_remuneraciones: "Otras remuneraciones",
		tutor_propuesto: "Tutor propuesto",
		aprobar: "Aprobar",
		denegar: "Denegar",
		estado: "Estado",
		aprobada: "Aprobada",
		denegada: "Denegada",
		pendiente_aprobacion: "Pendiente aprobación",
		indique_tutor: "Por favor indique el nombre y apellidos del tutor que tutorizaría al candidato seleccionado en esta oferta.",
		indique_motivo_rechazo: "Por favor indique el motivo del rechazo de la oferta de prácticas para su titulación.",
		motivo_denegacion: "Motivo denegación",
		selecciona_tutor: "Selecciona un tutor",
		continuar: "Continuar",
		cancelar: "Cancelar",
		modifica_columnas: "Modifica o añade columnas:",
		comunicaciones: "Comunicaciones",
		ver_mas: "Ver más",
		inicio: "Inicio",
		validaciones: "Validaciones",
		pendientes: "Pendientes",
		validadas: "Validadas",
		rechazadas: "Rechazadas",
		aprobacion_ofertas: "Aprobación ofertas",
		pendientes: "Pendientes",
		aprobadas: "Aprobadas",
		denegadas: "Denegadas",
		tutorados: "Tutorados",
		practicas_en_curso: "Prácticas en curso",
		pendiente_cierre: "Pendiente de cierre",
		cerrados: "Cerrados",
		firmas_anexos: "Firmas anexos",
		pendiente_firma: "Pendiente de firma",
		firmas_curso: "Firmas en curso",
		firmados: "Firmados",
		favoritos: "Favoritos",
		nombre_documentacion: "Nombre de la documentación",
		adjuntar: "Adjuntar",
		arrastra: "Arrastra el archivo o haz click para adjuntar",
		archivo_adjunto: "Archivo adjuntado correctamente",
		anadir: "Añadir",
		encuestas_obligatorias: "Encuestas Obligatorias",
		por_favor_responda: "Por favor, antes de continuar, responda estas encuestas",
		ver_practica_relacionada: "Ver práctica relacionada",
		si_no_deseas: "Si no deseas responderlas en estos momentos, por favor cierre su sesión",
		pincha_aqui: "pinchando aqui",
		seleccione_motivo_rechazo: "Seleccione a continuación el motivo del rechazo de esta práctica*.",
		seleccione_motivo: "Selecciona un motivo",
		por_favor_indique_motivo: "Por favor, indique a continuación el <strong>motivo o requisitos mínimos</strong> para poder rechazar la práctica*.",
		incluir_observacion: "Si lo desea, puede incluir una observación a continuación",
		autorizacion_cuatri: "Autorización por cuatrimestre",
		puede_adjuntar_documento: "Puede además adjuntar un documento a continuación.",
		listo_terminar: "Listo, terminar",
		revisar_perfil: "Por favor, acceda al menú Mi Perfil para completar sus datos.",
		descargar_certificado : "Descargar certificado de prácticas",
		popup_idioma :"Vas a cambiar tu preferencia de idioma. ¿Quieres continuar?",
		ficha: {
			estudiante: 'Estudiante',
			practica: 'Práctica',
			empresa: 'Empresa',
			observaciones: 'Observaciones',
			marcar_cerrada: "Marcar como cerrada",
			marcar_pendiente_cierre: "Marcar como pendiente de cierre",
			aviso_marcar_tramitada: "¡Atención! Vas a marcar esta evaluación como tramitada.<br>Este es un proceso irreversible.",
			continuar: "Continuar",
			cancelar: "Cancelar",
			listado_practicas: "Listado de prácticas",
		},
		home: {
			practicas_pendientes_validacion: "Prácticas pendientes de validación",
			ofertas_pendientes_validacion: "Ofertas pendientes de validación",
			practicas_pendientes_cierre: "Prácticas pendientes de cierre",
			tutorados: "Tutorados/as",
			favoritos: "Favoritos",
			anexos_pendientes_firma: "Anexos pendientes de firma"
		}

	},
	ca: {
		enlaces: {
			login: "/login",
			restablecer_login: "/restablir-tutor",
			validaciones: "/validacions",
			evaluaciones: "/avaluacions",
			tutorados: "/tutorats",
			ficha: "/fitxa",
			fichaaprobacion: "/aprovació",
			encuesta: "/enquesta",
			encuestas: "/encuestas",
			acceso: "/accés",
			miperfil: "/mi-perfil",
			aprobacionesdirector: "/aprovacions",
			1: "pendents",
			2: "validades",
			3: "rebutjades",
			anexos: '/anexos',
		},
		encabezado: {
			home: "Benvingut/Benvinguda",
			politica_privacidad: "Política de privacitat",
			politica_cookies: "Política de cookies",
			login: "Inici de sessió",
			documentacion: "Documentació",
			restablecer_login: "Restableix la contrasenya",
			encuesta: "Enquesta",
			acceso: "Accés"
		},
		escribe_buscar: "Escriu per cercar",
		no_hay_datos: "NO HI HA DADES",
		descargar: "Descarrega",
		columnas: "Columnes",
		encuestas: "Enquestes",
		comenzar: "Comença",
		ver_practica: "Veure pràctica relacionada",
		empresa: "Empresa",
		datos_empresa: "Dades de l'empresa",
		cif: "CIF",
		nombre_comercial: "Nom comercial",
		sector: "Sector",
		direccion: "Adreça",
		localidad: "Localitat",
		provincia: "Província",
		cp: "Codi postal",
		pais: "País",
		web_empresa: "Web de l'empresa",
		descripcion: "Descripció",
		contacto_empresa: "Contactes de l'empresa",
		nombre_apellidos: "Nom i cognoms",
		puesto: "Lloc",
		telefono: "Telèfon",
		email: "E-mail",
		estudiante: "Estudiant",
		datos_personales: "Dades personals",
		nombre: "Nom",
		apellidos: "Cognoms",
		movil: "Mòbil",
		fijo: "Fix",
		fecha_nacimiento: "Data de naixement",
		pais_nacionalidad: "País de nacionalitat",
		direccion: "Adreça",
		poblacion: "Població",
		provincia: "Província",
		discapacidad: "Discapacitat",
		si: "Sí",
		no: "No",
		documentos: "Documents",
		descargar: "Descarrega",
		datos_academicos: "Dades acadèmiques en curs",
		titulacion: "Titulació",
		matriculado_practicas: "Matriculat de pràctiques",
		practicas_pendientes: "Pràctiques pendents",
		ver_cv_estudiante: "Ver CV del estudiante",
		autorizacion_cuatrimestre: "Autorització per quadrimestre",
		anyo: "Any",
		codigo_estudio: "Codi destudi",
		autorizacion: "Autorització",
		periodo: "Període",
		fecha_resolucion: "Data de resolució",
		horas: "Hores",
		observaciones: "Observacions",
		no_tiene_observaciones: "Aquesta pràctica no conté observacions",
		datos_practica: "Dades de la pràctica",
		id_practica: "Id pràctica",
		nombre_gestor: "Nombre gestor",
		detalles_puesto: "Detalls del lloc",
		tipo_practica: "Tipus de pràctica",
		nombre_puesto: "Nom del lloc",
		area_funcional: "Àrea funcional",
		ayuda_al_estudio: "Ajuda a l'estudi",
		tareas_desarrollar: "Tasques a desenvolupar",
		tarea: "Tasca",
		otras_tareas: "Altres tasques",
		motivos_solicitud: "Motius de sol·licitud de validació",
		ver_documento_prorroga: "Veure document de pròrroga",
		duracion: "Durada",
		fecha_inicio: "Data d'inici",
		fecha_finalizacion: "Data de finalització",
		horario: "Horari",
		n_horas_dia: "Nre. d'hores al dia",
		horas_totales: "Hores totals",
		dias_semana: "Dies en setmana",
		horas_curriculares: "Hores curriculars",
		horas_extracurriculares: "Hores extracurriculars",
		numero_creditos: "Nombre de crèdits",
		nombre_centro: "Nom del centre de treball",
		tutor_empresa: "Tutor/a a l'empresa",
		departamento: "Departament",
		ver_anexo_practicas: "Veure document annex de pràctiques",
		cuestionarios: "Qüestionaris",
		ver_cuestionario_empresa: "Veure qüestionari de l'empresa",
		ver_cuestionario_alumno: "Ver cuestionario del alumno/a",
		ver_cuestionario_tutor: "Ver cuestionario del tutor/a académico/a",
		ver_actilla_calificacion: "Veure acte de qualificació",
		documento_evaluacion: "Documento de Evaluación del tutor/a",
		cuestionarios_tutor: "Cuestionarios del tutor/a académico/a contestados",
		seguimiento: "Seguiment",
		fecha_practica: "Data de pràctica assignada",
		fecha_limite_estudiante: "Data límit de lliurament estudiant",
		fecha_cuestionario_estudiante: "Data qüestionari/memòria estudiant",
		fecha_limite_empresa: "Data límit de lliurament empresa",
		fecha_cuestionario_empresa: "Data qüestionari empresa",
		fecha_cierre_pendiente: "Data de tancament pendent",
		fecha_cierre_tramitado: "Data de tancament tramitat",
		motivos_solicitud_validacion: "Motius per a la sol·licitud de la validació",
		documentacion_tutor: "Documentación del tutor/a académico/a",
		anadir_documentacion: "Afegir documentació",
		anadir_evaluacion: "Afegir avaluació",
		documentacion_por_programas: "Documentació per programes",
		ver_documento: "Veure document",
		documentacion_ofrecida: "Documentació oferta",
		documentacion_pendiente_subir: "Documentació pendent de pujar",
		anadir_documento: "Afegir document",
		iniciar_sesion: "Iniciar sessió",
		contrasena: "Contrasenya",
		he_perdido_contrasena: "He oblidat la meva contrasenya",
		acceder: "Accedir",
		introducir_email: "Introdueix el teu email",
		email_mal_formado: "El correu electrònic està mal format",
		recuperar_contrasena: "Recuperar la meva contrasenya",
		mi_perfil: "El meu perfil",
		datos_personales_contacto: "Dades personals i de contacte",
		sin_introducir: "Sense introduir",
		dni: "DNI/NIE",
		email_personal: "E-mail personal",
		telefono_profesional: "Telèfon professional/despatx",
		telefono_movil: "Telèfon mòbil",
		datos_profesionales: "Dades professionals",
		tipo: "Tipus",
		area: "Àrea",
		cargo: "Càrrec",
		datos_facturacion: "Dades de facturació",
		selecciona_pais: "-selecciona un país-",
		provincia: "Província",
		selecciona_provincia: "-selecciona una província-",
		localidad: "Localitat",
		direccion_fiscal: "Direcció Fiscal",
		numero_cuenta: "Número de compte, IBAN",
		editar_datos: "Edita dades",
		guardar_datos: "Guarda dades",
		si_datos_erroneos: "Si alguna de les dades no editables al teu perfil no és correcta, si us plau contacta amb nosaltres.",
		sigue_pasos: "Segueix els passos per restablir la contrasenya",
		nueva_contrasena: "Nova Contrasenya",
		repetir_contrasena: "Repetir nova Contrasenya",
		guardar: "Desa",
		ver_documento_adjunto: "Veure document adjunt",
		resultados_cuestionario: "Resultats del qüestionari",
		informacion_puesto: "Informació lloc",
		datos_generales: "Dades generals",
		titulaciones: "Titulacions",
		conocimientos_especificos: "Coneixements específics",
		formacion_adquirida: "Formació Adquirida",
		nombre_oferta: "Nom de l'oferta",
		n_plazas: "Nre. de places",
		descripcion_puesto: "Descripció del lloc",
		duracion: "Durada",
		horas_dia: "Hores/dia",
		horario: "Horari",
		localizacion: "Localització",
		detalles: "Detalls",
		remuneracion: "Remuneració",
		otras_remuneraciones: "Altres remuneracions",
		tutor_propuesto: "Tutor proposat",
		aprobar: "Aprovar",
		denegar: "Denegar",
		estado: "Estat",
		aprobada: "Aprovada",
		denegada: "Denegada",
		pendiente_aprobacion: "Pendent aprovació",
		indique_tutor: "Si us plau indiqueu el nom i cognoms del tutor que tutoritzaria el candidat seleccionat en aquesta oferta.",
		indique_motivo_rechazo: "Si us plau indiqueu el motiu del rebuig de l'oferta de pràctiques per a la vostra titulació.",
		motivo_denegacion: "Motiu de denegació",
		selecciona_tutor: "Selecciona un tutor",
		continuar: "Continuar",
		cancelar: "Cancel·lar",
		modifica_columnas: "Modifica o afegeix columnes:",
		comunicaciones: "Comunicacions",
		ver_mas: "Veure més",
		inicio: "Inici",
		validaciones: "Validacions",
		pendientes: "Pendents",
		validadas: "Validades",
		rechazadas: "Rebutjades",
		aprobacion_ofertas: "Aprovació d'ofertes",
		pendientes: "Pendents",
		aprobadas: "Aprovades",
		denegadas: "Denegades",
		tutorados: "Tutorats",
		practicas_en_curso: "Pràctiques en curs",
		pendiente_cierre: "Pendent de tancament",
		cerrados: "Tancats",
		favoritos: "Favorits",
		nombre_documentacion: "Nom de la documentació",
		adjuntar: "Adjuntar",
		arrastra: "Arrossega l'arxiu o fes clic per adjuntar",
		archivo_adjunto: "Arxiu adjuntat correctament",
		anadir: "Afegir",
		encuestas_obligatorias: "Enquestes obligatòries",
		por_favor_responda: "Si us plau, abans de continuar, responeu aquestes enquestes",
		ver_practica_relacionada: "Veure pràctica relacionada",
		si_no_deseas: "Si no voleu respondre-les en aquest moment, si us plau, tancau la sessió.",
		pincha_aqui: "clicant aquí",
		seleccione_motivo_rechazo: "Seleccionau a continuació el motiu del rebuig d'aquesta pràctica*.",
		seleccione_motivo: "Selecciona un motiu",
		por_favor_indique_motivo: "Si us plau, indiqueu a continuació el <strong>motiu o requisits mínims</strong> per poder rebutjar la pràctica*.",
		incluir_observacion: "Si voleu, podeu incloure una observació a continuació.",
		autorizacion_cuatri: "Autorització per quadrimestre",
		puede_adjuntar_documento: "Podeu, a més, adjuntar un document a continuació.",
		listo_terminar: "Llest, acaba",
		revisar_perfil: "Si us plau, accediu al menú El meu perfil per completar les dades.",
		descargar_certificado : "Descarregar certificat de pràctiques",
		popup_idioma :"Canviaràs la teva preferència d'idioma. Vols continuar?",
		ficha: {
			estudiante: "Estudiant",
			practica: "Pràctica",
			empresa: "Empresa",
			observaciones: "Observacions",
			marcar_cerrada: "Marca com a tancada",
			marcar_pendiente_cierre: "Marca com a pendent de tancament",
			aviso_marcar_tramitada: "Atenció! Marcareu aquesta avaluació com a tramitada.<br>Aquest és un procés irreversible.",
			continuar: "Continua",
			cancelar: "Cancel·la",
			listado_practicas: "Llista de pràctiques",
		},
		home: {
			practicas_pendientes_validacion: "Pràctiques pendents de validació",
			ofertas_pendientes_validacion: "Ofertes pendents de validació",
			practicas_pendientes_cierre: "Pràctiques pendents de tancament",
			tutorados: "Tutorats/ades",
			favoritos: "Favorits"

		}
	}
}



// WEBPACK FOOTER //
// ./src/translations/index.js